import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"];
  //
  connect() {

  }

  showhide() {
    this.itemTarget.classList.toggle("hidden")
  }
}
